import React, { FC } from "react";

import { PageAlert } from "@xapp/components";

export interface ServiceTitanAppUpgradeBannerProps {
    /**
     * True when the tenant has not yet accepted ServiceTitan app version 2 (the version that
     * carries the Accounting: Invoices (read) scope). The banner renders nothing otherwise.
     */
    upgradeRequired?: boolean;
}

/**
 * Tells a customer their ServiceTitan admin needs to accept the new app version, and what
 * accepting it unlocks. Shown in the integrations view when the capability flag says the
 * invoice-read scope is still refused for the tenant.
 */
export const ServiceTitanAppUpgradeBanner: FC<ServiceTitanAppUpgradeBannerProps> = ({ upgradeRequired }) => {
    if (!upgradeRequired) {
        return null;
    }

    return (
        <PageAlert background="orange">
            <p style={{ margin: 0 }}>
                <strong>ServiceTitan app upgrade needed.</strong> A ServiceTitan administrator needs to accept the new
                version of our app in your ServiceTitan account. The new app version adds invoice read access.
            </p>
            <p style={{ margin: "8px 0 0 0" }}>
                Once accepted, Studio can follow each lead through to its job outcome — including the invoiced and
                collected totals — right in your Leads view.
            </p>
        </PageAlert>
    );
};
